import React from 'react';
import style from './layout.module.sass'
import { ReactComponent as RowIcon } from '../../../../../../assets/svg/layoutIcons/row_sel.svg'
import { ReactComponent as ColIcon } from '../../../../../../assets/svg/layoutIcons/column_sel.svg'
import { ReactComponent as WrapIcon } from '../../../../../../assets/svg/layoutIcons/wrap_sel.svg'
import { ReactComponent as FillHeightIcon } from '../../../../../../assets/svg/layoutIcons/fillHeight_sel.svg'
import { ReactComponent as FillWidthIcon } from '../../../../../../assets/svg/layoutIcons/fillWidth_sel.svg'
import { ReactComponent as PxIcon } from '../../../../../../assets/svg/layoutIcons/px_sel.svg'
import { ReactComponent as PercentIcon } from '../../../../../../assets/svg/layoutIcons/percent_sel.svg'
import { ReactComponent as TopIcon } from '../../../../../../assets/svg/layoutIcons/top_sel.svg'
import { ReactComponent as BottomIcon } from '../../../../../../assets/svg/layoutIcons/bottom_sel.svg'
import { ReactComponent as LeftIcon } from '../../../../../../assets/svg/layoutIcons/left_sel.svg'
import { ReactComponent as RightIcon } from '../../../../../../assets/svg/layoutIcons/right_sel.svg'
import { ReactComponent as XCenterIcon } from '../../../../../../assets/svg/layoutIcons/xCenter_sel.svg'
import { ReactComponent as YCenterIcon } from '../../../../../../assets/svg/layoutIcons/yCenter_sel.svg'
import { ReactComponent as XDistributeIcon } from '../../../../../../assets/svg/layoutIcons/xDistribute_sel.svg'
import { ReactComponent as YDistributeIcon } from '../../../../../../assets/svg/layoutIcons/yDistribute_sel.svg'
import { ReactComponent as CheckboxIcon } from '../../../../../../assets/svg/layoutIcons/checkBox_sel.svg'
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { updateFormProperties } from '../../../../../../stateManager/store/formCreation/action';
import { updateAssetProperties } from '../../../../../../stateManager/store/assets/action';
import { findIdSelector } from '../reduxSelector';
import { Tooltip } from 'antd'
import { assetSelector } from '../../../../../../helpers/commonFunction'

interface IProps {
    json: any,
    canEdit: boolean
}

export const Layout = (props: IProps) => {

    const id = props.json && props.json.id;
    const params: any = useParams();
    const dispatch = useDispatch();

    const selectedAssetId = useSelector((state: any) => state.assets.selectedAssetId);
    const assets = useSelector((state: any) => state.assets.list);
    const assetEditMode = useSelector((state: any) => state.assets.assetEditMode);

    let json: any = useSelector((state) => {
        return (id) ? findIdSelector(state, params.formId, id.split("#"), true) : []
    });
    json = assetEditMode ? assetSelector(assets[selectedAssetId], id.split("#")) : json;
  
    const ignoreDimension = () => {
        const elementTypes = ["PdfViewer", "ImageViewer"];
        if (elementTypes.includes(json.type)) {
            return true;
        }
        return false;
    }

    const onChange = (data: any, key: string) => {
        if (!props.canEdit) return;
        const setData = _.setWith({}, key, data, Object)
        if (assetEditMode && selectedAssetId) {
            dispatch(
                updateAssetProperties({
                    assetId: selectedAssetId,
                    id,
                    data: setData,
                })
            );
        } else {
            dispatch(updateFormProperties({ formid: params.formId, id: json.id, data: setData }));
        }
    };

    const onFlexDirectionChange = (flexDirection: string) => {
        const layoutCopy = { ...json.properties.layout }
        if (layoutCopy.direction !== flexDirection) {
            layoutCopy.direction = flexDirection
            layoutCopy.horizontalChild = ''
            layoutCopy.verticalChild = ''

            const setDirection = _.setWith({}, 'properties.layout', layoutCopy, Object)

            const childFields = json.fields && json.fields.map((item: any) => {
                item.properties.layout.parent = flexDirection
                item.properties.layout.horizontal = ''
                item.properties.layout.vertical = ''
                item.properties.layout.height = ''
                item.properties.layout.width = ''
                item.properties.layout.heightMode = ''
                item.properties.layout.widthMode = ''
                item.properties.layout.minWidth = ''
                item.properties.layout.maxWidth = ''
                item.properties.layout.widthConstraint = false
                if (item.type === "Divider") {
                    item.properties.layout.widthMode = "fill"
                }
                return item
            })
            const setData = _.setWith(setDirection, 'fields', childFields, Object)
            if (assetEditMode && selectedAssetId) {
                dispatch(
                    updateAssetProperties({
                        assetId: selectedAssetId,
                        id,
                        data: setData,
                    })
                );
            } else {
                dispatch(updateFormProperties({ formid: params.formId, id: json.id, data: setData }));
            }
        }
    };

    const onAlignItemsChange = (value: string, property: string, childProperty: string) => {
        const setProperty = _.setWith({}, property, value, Object)
        const childFields = json.fields && json.fields.map((item: any) => {
            item.properties.layout[childProperty] = value
            return item
        })
        const setData = _.setWith(setProperty, 'fields', childFields, Object)
        if (assetEditMode && selectedAssetId) {
            dispatch(
                updateAssetProperties({
                    assetId: selectedAssetId,
                    id,
                    data: setData,
                })
            );
        } else {
            dispatch(updateFormProperties({ formid: params.formId, id: json.id, data: setData }));
        }
    };

    const onDimensionModeChange = (value: string, property: string, dimensionToBeCleared: string, previousValue: any) => {
        const dimensionMode = dimensionToBeCleared.split(".")
        if (value === '%' && ignoreDimension() && (dimensionMode[dimensionMode.length - 1] === "height" || dimensionMode[dimensionMode.length - 1] === "width")) {
            return null;
        }
        if (value === "%" && previousValue > 100) {
            previousValue = 100;
        }
        const setProperty = _.setWith({}, property, value, Object)
        const clearedDimension = _.setWith(setProperty, dimensionToBeCleared, previousValue || "", Object)
        // const setData = _.setWith(setProperty, 'fields', childFields, Object)
        if (assetEditMode && selectedAssetId) {
            dispatch(
                updateAssetProperties({
                    assetId: selectedAssetId,
                    id,
                    data: clearedDimension,
                })
            );
        } else {
            dispatch(updateFormProperties({ formid: params.formId, id: json.id, data: clearedDimension }));
        }
    }

    const layout: any = json && json.properties && json.properties.layout;

    const direction: string = layout && layout.direction;

    const isContainer: boolean = (layout && json && json.type === 'Container');
    const isRowContainer: boolean = isContainer && (direction === 'row');
    const isColContainer: boolean = isContainer && (direction === 'column');
    const isChild: boolean = (layout && layout.parent);
    const isRowChild: boolean = (isChild && layout.parent === 'row');
    const isColChild: boolean = (isChild && layout.parent === 'column');
    const isTopLevelContainer: boolean = isContainer && !isChild;

    const minWidthValue: string = (layout && layout.minWidth) || '';
    const maxWidthValue: string = (layout && layout.maxWidth) || '';
    const widthConstraint: boolean = (layout && layout.widthConstraint) || false;
    let heightMode: string = isTopLevelContainer ? '' : 'wrap';
    let widthMode: string = isTopLevelContainer ? '' : 'wrap';

    heightMode = (layout && (layout.heightMode ? layout.heightMode : heightMode));
    widthMode = (layout && (layout.widthMode ? layout.widthMode : widthMode));

    const heightValue: string = (layout && layout.height) || '';
    const widthValue: string = (layout && layout.width) || '';
    const marginTopValue: string = (layout && layout.marginTop) || '';
    const marginLeftValue: string = (layout && layout.marginLeft) || '';
    const marginRightValue: string = (layout && layout.marginRight) || '';
    const marginBottomValue: string = (layout && layout.marginBottom) || '';
    const paddingTopValue: string = (layout && layout.paddingTop) || '';
    const paddingLeftValue: string = (layout && layout.paddingLeft) || '';
    const paddingRightValue: string = (layout && layout.paddingRight) || '';
    const paddingBottomValue: string = (layout && layout.paddingBottom) || '';
    const horizontal: string = (layout && layout.horizontal) || (isColChild && 'flex-start');
    const vertical: string = (layout && layout.vertical) || (isRowChild && 'flex-start');
    const horizontalChild: string = (layout && layout.horizontalChild) || (isContainer && 'flex-start');
    const verticalChild: string = (layout && layout.verticalChild) || (isContainer && 'flex-start');

    const buttonIncrementHandler = (e: any, key: string) => {
        const keySplit = key.split('.')
        const dimension = keySplit[keySplit.length - 1]
        if (e.which === 37 || e.which === 40) {
            const value: number = parseInt(e.target.value) || 0
            value !== 0 ? onChange(value - 1, key) : onChange(value, key)
        } else if (e.which === 38 || e.which === 39) {
            const value: number = parseInt(e.target.value) || 0
            if ((dimension === 'height' && heightMode === '%') || (dimension === 'width' && widthMode === '%')) {
                value !== 100 ? onChange(value + 1, key) : onChange(value, key)
            }
            else {
                onChange(value + 1, key)
            }
        }
    }

    const previewContainerStyle: any = {
        display: 'flex',
        flexDirection: direction,
        justifyContent: direction === 'row' ? horizontalChild : verticalChild,
        alignItems: direction === 'row' ? verticalChild : horizontalChild,
        height: !isContainer && (isColChild ? 'max-content' : undefined),
        width: !isContainer && (isRowChild ? 'max-content' : undefined),
        position: !isContainer && 'relative',
        left: !isContainer && (isRowChild ? '50%' : undefined),
        top: !isContainer && (isColChild ? '50%' : undefined),
        transform: !isContainer && (isRowChild ? 'translateX(-50%)' : isColChild ? 'translateY(-50%)' : undefined),
        marginTop: !isContainer && (isColChild ? '64px' : undefined)
    }

    if (layout && json && json.type !== 'Container') {
        previewContainerStyle.justifyContent = layout.horizontal || 'flex-start';
        previewContainerStyle.alignItems = layout.vertical || 'flex-start';
    }

    return (
        (json && json.type !== 'TabBar' && (json.type === 'Container' || layout))
            ?
            <div className={style.layoutContainer}>
                <h3 className={style.darkTitleBlue} style={{ marginBottom: ' 18px' }}>Alignment</h3>

                <div className={style.previewContainer} style={previewContainerStyle}>
                    {
                        json.type !== 'Container' && (
                            <React.Fragment>
                                <div data-test-id="layout_preview" className={style.previewBox}></div>
                            </React.Fragment>
                        )
                    }
                    {
                        json.type === 'Container' && (
                            <React.Fragment>
                                {
                                    json.fields.map((item: any, i: number) => {
                                        return <div data-test-id={`layout_${i}`} key={i} className={style.previewBox}></div>
                                    })
                                }
                            </React.Fragment>
                        )
                    }
                </div>

                <div className={style.directionContainer}>
                    <h3 className={style.lightTitle}>Direction</h3>
                    <Tooltip title={isContainer ? '' : 'Not a container'} placement='top' overlayClassName='propertiesPopUp'>
                        <div className={style.buttonContainer}>
                            <div data-test-id="layout_direction_row" className={`${style.button} ${isContainer ? direction === 'row' ? style.active : null : style.disabled}`} onClick={() => props.canEdit && isContainer && onFlexDirectionChange('row')}>
                                <RowIcon />
                            </div>
                            <div data-test-id="layout_direction_column" className={`${style.button} ${isContainer ? direction === 'column' ? style.active : null : style.disabled}`} onClick={() => props.canEdit && isContainer && onFlexDirectionChange('column')}>
                                <ColIcon />
                            </div>
                        </div>
                    </Tooltip>
                </div>

                <div className={style.horizontalChildContainer}>
                    <h3 className={style.lightTitle}>Horizontal - Child</h3>
                    <Tooltip title={!isContainer ? 'Not a container' : ''} placement='top' overlayClassName='propertiesPopUp'>
                        <div data-test-id="layout_horizontal_child" className={style.buttonContainer}>
                            <div data-test-id="layout_horizontal_left" className={`${style.button} ${horizontalChild === 'flex-start' ? style.active : null} ${!isContainer ? style.disabled : null}`} onClick={() => {
                                if (props.canEdit) {
                                    isContainer && (direction === 'column'
                                        ?
                                        onAlignItemsChange('flex-start', 'properties.layout.horizontalChild', 'horizontal')
                                        :
                                        onChange('flex-start', 'properties.layout.horizontalChild'))
                                }
                            }}>
                                <LeftIcon />
                            </div>
                            <div data-test-id="layout_horizontal_center" className={`${style.button} ${horizontalChild === 'center' ? style.active : null} ${!isContainer ? style.disabled : null}`} onClick={() => {
                                if (props.canEdit) {
                                    isContainer && (direction === 'column'
                                        ?
                                        onAlignItemsChange('center', 'properties.layout.horizontalChild', 'horizontal')
                                        :
                                        onChange('center', 'properties.layout.horizontalChild'))
                                }
                            }}>
                                <XCenterIcon />
                            </div>
                            <div data-test-id="layout_horizontal_right" className={`${style.button} ${horizontalChild === 'flex-end' ? style.active : null} ${!isContainer ? style.disabled : null}`} onClick={() => {
                                if (props.canEdit) {
                                    isContainer && (direction === 'column'
                                        ?
                                        onAlignItemsChange('flex-end', 'properties.layout.horizontalChild', 'horizontal')
                                        :
                                        onChange('flex-end', 'properties.layout.horizontalChild'))
                                }
                            }}>
                                <RightIcon />
                            </div>
                            <Tooltip title={isColContainer ? 'Not a row container' : ''} placement='top' overlayClassName='propertiesPopUp'>
                                <div data-test-id="layout_horizontal_distribute" className={`${style.button} ${horizontalChild === 'space-evenly' ? style.active : null} ${isContainer ? isColContainer ? style.disabled : null : style.disabled}`} onClick={() => props.canEdit && isRowContainer && onChange('space-evenly', 'properties.layout.horizontalChild')}>
                                    <XDistributeIcon />
                                </div>
                            </Tooltip>
                        </div>
                    </Tooltip>
                </div>

                <div className={style.verticalChildContainer}>
                    <h3 className={style.lightTitle}>Vertical - Child</h3>
                    <Tooltip title={!isContainer ? 'Not a container' : ''} placement='top' overlayClassName='propertiesPopUp'>
                        <div data-test-id="layout_vertical_child" className={style.buttonContainer}>
                            <div data-test-id="layout_vertical_top" className={`${style.button} ${verticalChild === 'flex-start' ? style.active : null} ${!isContainer ? style.disabled : null}`} onClick={() => {
                                if (props.canEdit) {
                                    isContainer && (direction === 'row'
                                        ?
                                        onAlignItemsChange('flex-start', 'properties.layout.verticalChild', 'vertical')
                                        :
                                        onChange('flex-start', 'properties.layout.verticalChild'))
                                }
                            }}>
                                <TopIcon />
                            </div>
                            <div data-test-id="layout_vertical_center" className={`${style.button} ${verticalChild === 'center' ? style.active : null} ${!isContainer ? style.disabled : null}`} onClick={() => {
                                if (props.canEdit) {
                                    isContainer && (direction === 'row'
                                        ?
                                        onAlignItemsChange('center', 'properties.layout.verticalChild', 'vertical')
                                        :
                                        onChange('center', 'properties.layout.verticalChild'))
                                }
                            }}>
                                <YCenterIcon />
                            </div>
                            <div data-test-id="layout_vertical_bottom" className={`${style.button} ${verticalChild === 'flex-end' ? style.active : null} ${!isContainer ? style.disabled : null}`} onClick={() => {
                                if (props.canEdit) {
                                    isContainer && (direction === 'row'
                                        ?
                                        onAlignItemsChange('flex-end', 'properties.layout.verticalChild', 'vertical')
                                        :
                                        onChange('flex-end', 'properties.layout.verticalChild'))
                                }
                            }}>
                                <BottomIcon />
                            </div>
                            <Tooltip title={isRowContainer ? 'Not a column container' : ''} placement='top' overlayClassName='propertiesPopUp'>
                                <div data-test-id="layout_vertical_space_evenly" className={`${style.button} ${verticalChild === 'space-evenly' ? style.active : null} ${isContainer ? isRowContainer ? style.disabled : null : style.disabled}`} onClick={() => props.canEdit && isColContainer && onChange('space-evenly', 'properties.layout.verticalChild')}>
                                    <YDistributeIcon />
                                </div>
                            </Tooltip>
                        </div>
                    </Tooltip>
                </div>

                <div className={style.horizontalContainer}>
                    <h3 className={style.lightTitle} >Horizontal</h3>
                    <Tooltip title={!isColChild ? `Only for column's child` : ''} placement='top' overlayClassName='propertiesPopUp'>
                        <div data-test-id="layout_horizontal" className={style.buttonContainer}>
                            <div data-test-id="layout_horizontal_left" className={`${style.button} ${horizontal === 'flex-start' ? style.active : null} ${!isColChild ? style.disabled : null}`} onClick={() => props.canEdit && isColChild && onChange('flex-start', 'properties.layout.horizontal')}>
                                <LeftIcon />
                            </div>
                            <div data-test-id="layout_horizontal_center" className={`${style.button} ${horizontal === 'center' ? style.active : null} ${!isColChild ? style.disabled : null}`} onClick={() => props.canEdit && isColChild && onChange('center', 'properties.layout.horizontal')}>
                                <XCenterIcon />
                            </div>
                            <div data-test-id="layout_horizontal_right" className={`${style.button} ${horizontal === 'flex-end' ? style.active : null} ${!isColChild ? style.disabled : null}`} onClick={() => props.canEdit && isColChild && onChange('flex-end', 'properties.layout.horizontal')}>
                                <RightIcon />
                            </div>
                        </div>
                    </Tooltip>
                </div>

                <div className={style.verticalContainer}>
                    <h3 className={style.lightTitle}>Vertical</h3>
                    <Tooltip title={!isRowChild ? `Only for row's child` : ''} placement='top' overlayClassName='propertiesPopUp'>
                        <div data-test-id="layout_vertical" className={style.buttonContainer}>
                            <div data-test-id="layout_vertical_top" className={`${style.button} ${vertical === 'flex-start' ? style.active : null} ${!isRowChild ? style.disabled : null}`} onClick={() => props.canEdit && isRowChild && onChange('flex-start', 'properties.layout.vertical')}>
                                <TopIcon />
                            </div>
                            <div data-test-id="layout_vertical_center" className={`${style.button} ${vertical === 'center' ? style.active : null} ${!isRowChild ? style.disabled : null}`} onClick={() => props.canEdit && isRowChild && onChange('center', 'properties.layout.vertical')}>
                                <YCenterIcon />
                            </div>
                            <div data-test-id="layout_vertical_bottom" className={`${style.button} ${vertical === 'flex-end' ? style.active : null} ${!isRowChild ? style.disabled : null}`} onClick={() => props.canEdit && isRowChild && onChange('flex-end', 'properties.layout.vertical')}>
                                <BottomIcon />
                            </div>
                        </div>
                    </Tooltip>
                </div>

                <div className={style.divider}></div>

                <h3 className={style.darkTitleBlue} style={{ margin: '16px 0 24px' }}>
                    Dimension
                </h3>

                <div className={style.heightContainer}>
                    <h3 className={style.lightTitle}>Height</h3>
                    <div data-test-id="layout_height" className={style.buttonContainer}>
                        <Tooltip title={isTopLevelContainer ? 'Not allowed for outer containers' : ''} placement='top' overlayClassName='propertiesPopUp'>
                            <div data-test-id="layout_height_fill" className={`${style.button} ${heightMode === 'fill' ? style.active : null} ${isTopLevelContainer ? style.disabled : null}`} onClick={() => props.canEdit && !isTopLevelContainer && onChange('fill', 'properties.layout.heightMode')}>
                                <FillHeightIcon style={{ height: '16px' }} />
                            </div>
                        </Tooltip>
                        <Tooltip title={isTopLevelContainer ? 'Not allowed for outer containers' : (json.type === 'Image' || json.type === 'ImageViewer') ? 'Not allowed for image component' : ''} placement='top' overlayClassName='propertiesPopUp'>
                            <div data-test-id="layout_height_wrap" className={`${style.button} ${heightMode === 'wrap' ? style.active : null} ${(isTopLevelContainer || (json.type === 'Image' || json.type === 'ImageViewer')) ? style.disabled : null}`} onClick={() => props.canEdit && !isTopLevelContainer && (json.type !== 'Image' && json.type !== "ImageViewer") && onChange('wrap', 'properties.layout.heightMode')}>
                                <WrapIcon style={{ height: '20px', width: '18px' }} />
                            </div>
                        </Tooltip>
                        <div data-test-id="layout_height_percent" className={`${ignoreDimension() ? style.disabled : ""} ${style.button} ${heightMode === '%' ? style.active : null}`} onClick={() => props.canEdit && onDimensionModeChange('%', 'properties.layout.heightMode', 'properties.layout.height', heightValue)}>
                            <PercentIcon style={{ height: '14px', width: '14px' }} />
                        </div>
                        <div data-test-id="layout_height_px" className={`${style.button} ${heightMode === 'px' ? style.active : null}`} onClick={() => props.canEdit && onDimensionModeChange('px', 'properties.layout.heightMode', 'properties.layout.height', heightValue)}>
                            <PxIcon style={{ width: '18px' }} />
                        </div>
                    </div>
                    {
                        (heightMode === '%' || heightMode === 'px')
                            ?
                            <div data-test-id="layout_height_in" className={style.heightInputContainer}>
                                <h3 className={style.lightTitle}>Height in {heightMode}</h3>
                                <input data-test-id="layout_height_input" disabled={!props.canEdit} value={heightValue} onKeyDown={(e: any) => buttonIncrementHandler(e, 'properties.layout.height')} onChange={(e: any) => {
                                    let value = e.target.value
                                    const isValid = !isNaN(value)
                                    if (heightMode === '%' && isValid && value > 100) {
                                        value = 100
                                    }
                                    isValid && onChange(value, 'properties.layout.height')
                                }}></input>
                            </div>
                            :
                            null
                    }
                </div>

                <div className={style.widthContainer}>
                    <div className={style.widthTitleConstraintContainer}>
                        <h3 className={style.lightTitle}>Width</h3>
                        <Tooltip title={isTopLevelContainer ? 'Not allowed for outer containers' : isColChild ? `Only for row's child` : ''} placement='top' overlayClassName='propertiesPopUp'>
                            <div data-test-id="layout_width_constraint" className={style.constraintContainer} style={{ cursor: (!isColChild && !isTopLevelContainer) ? 'pointer' : 'not-allowed' }} onClick={() => props.canEdit && !isColChild && !isTopLevelContainer && onChange(!widthConstraint, 'properties.layout.widthConstraint')}>
                                <h3 className={style.lightTitle} style={{ color: (isColChild || isTopLevelContainer) ? '#ababab' : undefined }}>Constraints</h3>
                                <div className={`${style.widthConstraintCheck} ${widthConstraint ? style.checkAnimate : null} ${(isColChild || isTopLevelContainer) ? style.disabled : null}`}>
                                    {widthConstraint ?
                                        <CheckboxIcon />
                                        :
                                        null
                                    }
                                </div>
                            </div>
                        </Tooltip>
                    </div>
                    {
                        !widthConstraint ?

                            <div data-test-id="layout_width" className={style.buttonContainer}>
                                <Tooltip title={isTopLevelContainer ? 'Not allowed for outer containers' : ''} placement='top' overlayClassName='propertiesPopUp'>
                                    <div data-test-id="layout_width_fill" className={`${style.button} ${widthMode === 'fill' ? style.active : null} ${isTopLevelContainer ? style.disabled : null}`} onClick={() => props.canEdit && !isTopLevelContainer && onChange('fill', 'properties.layout.widthMode')}>
                                        <FillWidthIcon style={{ width: '18px' }} />
                                    </div>
                                </Tooltip>
                                <Tooltip title={isTopLevelContainer ? 'Not allowed for outer containers' : (json.type === 'Image' || json.type === 'ImageViewer') ? 'Not allowed for image component' : ''} placement='top' overlayClassName='propertiesPopUp'>
                                    <div data-test-id="layout_width_wrap" className={`${style.button} ${widthMode === 'wrap' ? style.active : null} ${(isTopLevelContainer || json.type === 'Image') ? style.disabled : null}`} onClick={() => props.canEdit && !isTopLevelContainer && (json.type !== 'Image' && json.type !== 'ImageViewer') && onChange('wrap', 'properties.layout.widthMode')}>
                                        <WrapIcon style={{ height: '20px', width: '18px' }} />
                                    </div>
                                </Tooltip>
                                <div data-test-id="layout_width_percent" className={`${ignoreDimension() ? style.disabled : ""} ${style.button} ${widthMode === '%' ? style.active : null}`} onClick={() => props.canEdit && onDimensionModeChange('%', 'properties.layout.widthMode', 'properties.layout.width', widthValue)}>
                                    <PercentIcon style={{ height: '14px', width: '14px' }} />
                                </div>
                                <div data-test-id="layout_width_px" className={`${style.button} ${widthMode === 'px' ? style.active : null}`} onClick={() => props.canEdit && onDimensionModeChange('px', 'properties.layout.widthMode', 'properties.layout.width', widthValue)}>
                                    <PxIcon style={{ width: '18px' }} />
                                </div>
                            </div>

                            :

                            <div className={style.inputRow}>
                                <div className={style.inputContainer}>
                                    <h3 className={style.lightTitle}>Min-width</h3>
                                    <div data-test-id="layout_minwidth" className={style.inputBoxContainer}>
                                        <input disabled={!props.canEdit} className={style.input} onKeyDown={(e: any) => buttonIncrementHandler(e, 'properties.layout.minWidth')} value={minWidthValue} onChange={(e: any) => {
                                            const value = e.target.value
                                            !isNaN(value) && onChange(value, 'properties.layout.minWidth')
                                        }}></input>
                                        <h3 className={style.unit}>px</h3>
                                    </div>
                                </div>
                                <div className={style.inputContainer}>
                                    <h3 className={style.lightTitle}>Max-width</h3>
                                    <div data-test-id="layout_width_maxwidth" className={style.inputBoxContainer}>
                                        <input disabled={!props.canEdit} className={style.input} onKeyDown={(e: any) => buttonIncrementHandler(e, 'properties.layout.maxWidth')} value={maxWidthValue} onChange={(e: any) => {
                                            const value = e.target.value
                                            !isNaN(value) && onChange(value, 'properties.layout.maxWidth')
                                        }}></input>
                                        <h3 className={style.unit}>px</h3>
                                    </div>
                                </div>
                            </div>

                    }
                    {
                        (widthMode === '%' || widthMode === 'px') && !(widthConstraint)
                            ?
                            <div className={style.widthInputContainer}>
                                <h3 className={style.lightTitle}>Width in {widthMode}</h3>
                                <input data-test-id="layout_width_in" disabled={!props.canEdit} value={widthValue} onKeyDown={(e: any) => buttonIncrementHandler(e, 'properties.layout.width')} onChange={(e: any) => {
                                    let value = e.target.value
                                    const isValid = !isNaN(value)
                                    if (widthMode === '%' && isValid && value > 100) {
                                        value = 100
                                    }
                                    isValid && onChange(value, 'properties.layout.width')
                                }}></input>
                            </div>
                            :
                            null
                    }
                    {

                    }
                </div>

                <div className={style.divider}></div>

                <div className={style.marginContainer}>
                    <h3 className={style.darkTitleBlue}>
                        Margin
                    </h3>
                    <div className={style.inputRow}>
                        <div data-test-id="layout_margin" className={style.inputContainer}>
                            <h3 className={style.lightTitle}>Left</h3>
                            <div data-test-id="layout_margin_left" className={style.inputBoxContainer}>
                                <input data-test-id="layout_margin_left_input" disabled={!props.canEdit} className={style.input} onKeyDown={(e: any) => buttonIncrementHandler(e, 'properties.layout.marginLeft')} value={marginLeftValue} onChange={(e: any) => {
                                    const value = e.target.value
                                    !isNaN(value) && onChange(value, 'properties.layout.marginLeft')
                                }}></input>
                                <h3 className={style.unit}>px</h3>
                            </div>
                        </div>
                        <div className={style.inputContainer}>
                            <h3 className={style.lightTitle}>Right</h3>
                            <div data-test-id="layout_margin_right" className={style.inputBoxContainer}>
                                <input data-test-id="layout_margin_right_input" disabled={!props.canEdit} className={style.input} onKeyDown={(e: any) => buttonIncrementHandler(e, 'properties.layout.marginRight')} value={marginRightValue} onChange={(e: any) => {
                                    const value = e.target.value
                                    !isNaN(value) && onChange(value, 'properties.layout.marginRight')
                                }}></input>
                                <h3 className={style.unit}>px</h3>
                            </div>
                        </div>
                    </div>
                    <div className={style.inputRow}>
                        <div className={style.inputContainer}>
                            <h3 className={style.lightTitle}>Top</h3>
                            <div data-test-id="layout_margin_top" className={style.inputBoxContainer}>
                                <input data-test-id="layout_margin_top_input" disabled={!props.canEdit} className={style.input} value={marginTopValue} onKeyDown={(e: any) => buttonIncrementHandler(e, 'properties.layout.marginTop')} onChange={(e: any) => {
                                    const value = e.target.value
                                    !isNaN(value) && onChange(value, 'properties.layout.marginTop')
                                }}></input>
                                <h3 className={style.unit}>px</h3>
                            </div>
                        </div>
                        <div className={style.inputContainer}>
                            <h3 className={style.lightTitle}>Bottom</h3>
                            <div data-test-id="layout_margin_bottom" className={style.inputBoxContainer}>
                                <input data-test-id="layout_margin_bottom_input" disabled={!props.canEdit} className={style.input} value={marginBottomValue} onKeyDown={(e: any) => buttonIncrementHandler(e, 'properties.layout.marginBottom')} onChange={(e: any) => {
                                    const value = e.target.value
                                    !isNaN(value) && onChange(value, 'properties.layout.marginBottom')
                                }}></input>
                                <h3 className={style.unit}>px</h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={style.divider}></div>

                <div className={style.paddingContainer}>
                    <h3 className={style.darkTitleBlue}>
                        Padding
                    </h3>
                    <div data-test-id="layout_padding" className={style.inputRow}>
                        <div className={style.inputContainer}>
                            <h3 className={style.lightTitle}>Left</h3>
                            <div data-test-id="layout_padding_left" className={style.inputBoxContainer}>
                                <input data-test-id="layout_padding_left_input" disabled={!props.canEdit} className={style.input} value={paddingLeftValue} onKeyDown={(e: any) => buttonIncrementHandler(e, 'properties.layout.paddingLeft')} onChange={(e: any) => {
                                    const value = e.target.value
                                    !isNaN(value) && onChange(value, 'properties.layout.paddingLeft')
                                }}></input>
                                <h3 className={style.unit}>px</h3>
                            </div>
                        </div>
                        <div className={style.inputContainer}>
                            <h3 className={style.lightTitle}>Right</h3>
                            <div data-test-id="layout_padding_right" className={style.inputBoxContainer}>
                                <input data-test-id="layout_padding_right_input" disabled={!props.canEdit} className={style.input} value={paddingRightValue} onKeyDown={(e: any) => buttonIncrementHandler(e, 'properties.layout.paddingRight')} onChange={(e: any) => {
                                    const value = e.target.value
                                    !isNaN(value) && onChange(value, 'properties.layout.paddingRight')
                                }}></input>
                                <h3 className={style.unit}>px</h3>
                            </div>
                        </div>
                    </div>
                    <div className={style.inputRow}>
                        <div className={style.inputContainer}>
                            <h3 className={style.lightTitle}>Top</h3>
                            <div data-test-id="layout_padding_top" className={style.inputBoxContainer}>
                                <input data-test-id="layout_padding_top_input" disabled={!props.canEdit} className={style.input} value={paddingTopValue} onKeyDown={(e: any) => buttonIncrementHandler(e, 'properties.layout.paddingTop')} onChange={(e: any) => {
                                    const value = e.target.value
                                    !isNaN(value) && onChange(value, 'properties.layout.paddingTop')
                                }}></input>
                                <h3 className={style.unit}>px</h3>
                            </div>
                        </div>
                        <div className={style.inputContainer}>
                            <h3 className={style.lightTitle}>Bottom</h3>
                            <div data-test-id="layout_padding_bottom" className={style.inputBoxContainer}>
                                <input data-test-id="layout_padding_boottom_input" disabled={!props.canEdit} className={style.input} value={paddingBottomValue} onKeyDown={(e: any) => buttonIncrementHandler(e, 'properties.layout.paddingBottom')} onChange={(e: any) => {
                                    const value = e.target.value
                                    !isNaN(value) && onChange(value, 'properties.layout.paddingBottom')
                                }}></input>
                                <h3 className={style.unit}>px</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            :
            null
    )
}
